import { render } from "./DataSourceSelector.vue?vue&type=template&id=53e93ebf&scoped=true"
import script from "./DataSourceSelector.vue?vue&type=script&lang=js"
export * from "./DataSourceSelector.vue?vue&type=script&lang=js"

import "./DataSourceSelector.vue?vue&type=style&index=0&id=53e93ebf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e93ebf"]])

export default __exports__